// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PED_VEN_MODO_CUSTEIO = {
  CustoDaControladoria: 'PED_VEN_MODO_CUSTEIO1',
  CustoDoEstoque: 'PED_VEN_MODO_CUSTEIO2',
  CustoSimulado: 'PED_VEN_MODO_CUSTEIO3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PED_VEN_MODO_CUSTEIO1: 1,
    PED_VEN_MODO_CUSTEIO2: 2,
    PED_VEN_MODO_CUSTEIO3: 3
  }
}
